import NotificationsSummaryRepository from '@/repositories/NotificationsSummaryRepository'
import PatientLiveStatesRepository from '@/repositories/PatientLiveStatesRepository'

const notificationsStore = {
	namespaced: true,
	state: {
		notifications: [],
		unreadNotifications: [],
		unreadNotificationsNumber: null,
		lastNotification: null,
		liveStates: [],
		retrievedLiveStates: false,
		summary: {
			unreadChatMessagesNumber: null,
			unreadFilesNumber: null
		}
	},
	mutations: {
		setNotifications (state, notifications) {
			state.notifications = notifications
		},
		setUnreadNotifications (state, notifications) {
			state.unreadNotifications = notifications
		},
		setLastNotification (state, notification) {
			state.lastNotification = notification
		},
		setLiveStates (state, liveStates) {
			state.liveStates = liveStates
		},
		setRetrievedLiveStates (state, value) {
			state.retrievedLiveStates = value
		},
		addLiveState (state, liveState) {
			state.liveStates = [...state.liveStates, liveState]
		},
		removeLiveState (state, liveState) {
			state.liveStates = state.liveStates.filter((state) => state.id !== liveState.id)
		},
		setSummary (state, summary) {
			state.summary = summary
		},
		setUnreadNotificationsNumber (state, number) {
			state.unreadNotificationsNumber = number
		}
	},
	getters: {
		unreadNotificationsCount: (state) => state.unreadNotificationsNumber || state.unreadNotifications.length,
		getUnreadChatMessagesNumber: (state) => state.summary ? state.summary.unreadChatMessagesNumber : 0,
		getUnreadFilesNumber: (state) => state.summary ? state.summary.unreadFilesNumber : 0
	},
	actions: {
		getSummary ({ state, dispatch }) {
			// Do not retrieve summary from server if it is already set
			if (state.summary.unreadChatMessagesNumber === null || state.summary.unreadFilesNumber === null) {
				dispatch('updateSummary')
			}
		},
		updateSummary ({ commit }) {
			NotificationsSummaryRepository.getAll().then((response) => {
				commit('setSummary', response.data)
			})
		},
		getUnreadNotificationsNumber ({ commit }) {
			/* NotificationsRepository.getUnreadNotificationsNumber().then((response) => {
				commit('setUnreadNotificationsNumber', response.data)
			}) */
		},
		onNewNotification ({ commit }, notification) {
			commit('setLastNotification', notification)
			commit('setNotifications', [notification, ...state.notifications])
			commit('setUnreadNotificationsNumber', (state.unreadNotificationsNumber || 0) + 1)
		},
		resetState ({ commit }) {
			commit('setNotifications', [])
			commit('setUnreadNotifications', [])
			commit('setUnreadNotificationsNumber', null)
			commit('setLastNotification', null)
			commit('setRetrievedLiveStates', false)
		},
		updateLiveStates ({ commit }) {
			PatientLiveStatesRepository.getAll().then((response) => {
				const liveStates = response && response.data ? response.data : []
				commit('setLiveStates', liveStates)
				commit('setRetrievedLiveStates', true)
			})
		},
		get ({ dispatch }) {
			dispatch('updateSummary')
			dispatch('updateLiveStates')
		}
	}
}

export default notificationsStore


// WEBPACK FOOTER //
// ./src/store/modules/notifications.js